/**
 * English display name for an ISO 3166-1 alpha-2 country code, from the
 * browser's own locale data. Falls back to the code itself when the runtime
 * cannot name it.
 */
export function countryName(code: string): string {
  const normalized = code.trim().toUpperCase();
  try {
    return (
      new Intl.DisplayNames(["en"], { type: "region" }).of(normalized) ??
      normalized
    );
  } catch {
    return normalized;
  }
}
